import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Diagnostics from "../pages/diagnostics/page";
import Tarifs from "../pages/tarifs/page";
import DpePage from "../pages/diagnostics/dpe/page";
import PackVentePage from "../pages/diagnostics/pack-vente/page";
import PackLocationPage from "../pages/diagnostics/pack-location/page";
import AmiantePage from "../pages/diagnostics/amiante/page";
import PlombPage from "../pages/diagnostics/plomb/page";
import ElectricitePage from "../pages/diagnostics/electricite/page";
import GazPage from "../pages/diagnostics/gaz/page";
import TermitesPage from "../pages/diagnostics/termites/page";
import LoiCarrezPage from "../pages/diagnostics/loi-carrez/page";
import DevisPage from "../pages/devis/page";
import ContactPage from "../pages/contact/page";
import AvisPage from "../pages/avis/page";
import AProposPage from "../pages/a-propos/page";
import LpDpeParisExpress from "../pages/lp/dpe-paris-express/page";
import LpDpeIleDeFrance from "../pages/lp/dpe-ile-de-france/page";
import LpPackDiagnostic from "../pages/lp/pack-diagnostic/page";
import ZonesPage from "../pages/zones/page";
import BlogPage from "../pages/blog/page";
import BlogArticlePage from "../pages/blog/[slug]/page";
import Paris75Page from "../pages/zones/paris-75/page";
import HautsDeSeine92Page from "../pages/zones/hauts-de-seine-92/page";
import ValDeMarne94Page from "../pages/zones/val-de-marne-94/page";
import SeineSaintDenis93Page from "../pages/zones/seine-saint-denis-93/page";
import Essonne91Page from "../pages/zones/essonne-91/page";
import Yvelines78Page from "../pages/zones/yvelines-78/page";
import ValDOise95Page from "../pages/zones/val-d-oise-95/page";
import SeineEtMarne77Page from "../pages/zones/seine-et-marne-77/page";
import ParisArrCentrePage from "../pages/arrondissements/centre/page";
import ParisArrRiveGauchePage from "../pages/arrondissements/rive-gauche/page";
import ParisArrNordouestPage from "../pages/arrondissements/nord-ouest/page";
import ParisArrEstPage from "../pages/arrondissements/est/page";
import ParisArrSudPage from "../pages/arrondissements/sud/page";
import ParisArrOuestPage from "../pages/arrondissements/ouest/page";
import ParisArrNordPage from "../pages/arrondissements/nord/page";
// Villes IDF (Phase 2)
import CityBoulogneBillancourtPage from "../pages/cities/boulogne-billancourt/page";
import CityNanterrePage from "../pages/cities/nanterre/page";
import CityCourbevoiePage from "../pages/cities/courbevoie/page";
import CityLevalloisPerretPage from "../pages/cities/levallois-perret/page";
import CityIssyLesMoulineauxPage from "../pages/cities/issy-les-moulineaux/page";
import CitySaintDenisPage from "../pages/cities/saint-denis/page";
import CityMontreuilPage from "../pages/cities/montreuil/page";
import CityAubervilliersPage from "../pages/cities/aubervilliers/page";
import CityCreteilPage from "../pages/cities/creteil/page";
import CityVincennesPage from "../pages/cities/vincennes/page";
import CitySaintMaurDesFossesPage from "../pages/cities/saint-maur-des-fosses/page";
import CityVersaillesPage from "../pages/cities/versailles/page";
import CitySaintGermainEnLayePage from "../pages/cities/saint-germain-en-laye/page";
import CityMantesLaJoliePage from "../pages/cities/mantes-la-jolie/page";
import CityEvryCourcouronnesPage from "../pages/cities/evry-courcouronnes/page";
import CityMassyPage from "../pages/cities/massy/page";
import CityMeauxPage from "../pages/cities/meaux/page";
import CityMelunPage from "../pages/cities/melun/page";
import CityCergyPage from "../pages/cities/cergy/page";
import CityArgenteuilPage from "../pages/cities/argenteuil/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/diagnostics", element: <Diagnostics /> },
  { path: "/diagnostics/dpe", element: <DpePage /> },
  { path: "/diagnostics/pack-vente", element: <PackVentePage /> },
  { path: "/diagnostics/pack-location", element: <PackLocationPage /> },
  { path: "/diagnostics/amiante", element: <AmiantePage /> },
  { path: "/diagnostics/plomb", element: <PlombPage /> },
  { path: "/diagnostics/electricite", element: <ElectricitePage /> },
  { path: "/diagnostics/gaz", element: <GazPage /> },
  { path: "/diagnostics/termites", element: <TermitesPage /> },
  { path: "/diagnostics/loi-carrez", element: <LoiCarrezPage /> },
  { path: "/tarifs", element: <Tarifs /> },
  { path: "/devis", element: <DevisPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/avis", element: <AvisPage /> },
  { path: "/a-propos", element: <AProposPage /> },
  { path: "/lp/dpe-paris-express", element: <LpDpeParisExpress /> },
  { path: "/lp/dpe-ile-de-france", element: <LpDpeIleDeFrance /> },
  { path: "/lp/pack-diagnostic", element: <LpPackDiagnostic /> },
  { path: "/zones", element: <ZonesPage /> },
  { path: "/zones/paris-75", element: <Paris75Page /> },
  { path: "/zones/hauts-de-seine-92", element: <HautsDeSeine92Page /> },
  { path: "/zones/val-de-marne-94", element: <ValDeMarne94Page /> },
  { path: "/zones/seine-saint-denis-93", element: <SeineSaintDenis93Page /> },
  { path: "/zones/essonne-91", element: <Essonne91Page /> },
  { path: "/zones/yvelines-78", element: <Yvelines78Page /> },
  { path: "/zones/val-d-oise-95", element: <ValDOise95Page /> },
  { path: "/zones/seine-et-marne-77", element: <SeineEtMarne77Page /> },
  // Paris arrondissements (groupés) — SEO ultra-local
  { path: "/paris/centre", element: <ParisArrCentrePage /> },
  { path: "/paris/rive-gauche", element: <ParisArrRiveGauchePage /> },
  { path: "/paris/nord-ouest", element: <ParisArrNordouestPage /> },
  { path: "/paris/est", element: <ParisArrEstPage /> },
  { path: "/paris/sud", element: <ParisArrSudPage /> },
  { path: "/paris/ouest", element: <ParisArrOuestPage /> },
  { path: "/paris/nord", element: <ParisArrNordPage /> },
  // Villes IDF (Phase 2) — SEO local ultra-ciblé
  { path: "/villes/boulogne-billancourt", element: <CityBoulogneBillancourtPage /> },
  { path: "/villes/nanterre", element: <CityNanterrePage /> },
  { path: "/villes/courbevoie", element: <CityCourbevoiePage /> },
  { path: "/villes/levallois-perret", element: <CityLevalloisPerretPage /> },
  { path: "/villes/issy-les-moulineaux", element: <CityIssyLesMoulineauxPage /> },
  { path: "/villes/saint-denis", element: <CitySaintDenisPage /> },
  { path: "/villes/montreuil", element: <CityMontreuilPage /> },
  { path: "/villes/aubervilliers", element: <CityAubervilliersPage /> },
  { path: "/villes/creteil", element: <CityCreteilPage /> },
  { path: "/villes/vincennes", element: <CityVincennesPage /> },
  { path: "/villes/saint-maur-des-fosses", element: <CitySaintMaurDesFossesPage /> },
  { path: "/villes/versailles", element: <CityVersaillesPage /> },
  { path: "/villes/saint-germain-en-laye", element: <CitySaintGermainEnLayePage /> },
  { path: "/villes/mantes-la-jolie", element: <CityMantesLaJoliePage /> },
  { path: "/villes/evry-courcouronnes", element: <CityEvryCourcouronnesPage /> },
  { path: "/villes/massy", element: <CityMassyPage /> },
  { path: "/villes/meaux", element: <CityMeauxPage /> },
  { path: "/villes/melun", element: <CityMelunPage /> },
  { path: "/villes/cergy", element: <CityCergyPage /> },
  { path: "/villes/argenteuil", element: <CityArgenteuilPage /> },
  { path: "/blog", element: <BlogPage /> },
  { path: "/blog/:slug", element: <BlogArticlePage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
